var React = require('react');

function Share (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.9997 4V9H10.9997C2.49969 9 2.99968 18 2.99968 19C3.83301 17.6667 4.99968 15 8.99968 15H12.9997V20L20.4997 12L12.9997 4Z","stroke":"currentColor","strokeWidth":"2"}));
}

Share.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Share;

Share.default = Share;
